<template>
  <div class="home">
    <div class="banner" v-if="carouselList.length > 0">
      <!--<img src="../../assets/topHeader.png" alt="" class="bannerImg">-->
      <van-swipe :autoplay="3000" :height="173">
        <van-swipe-item v-for="(item, index) in carouselList" :key="index">
          <img :src="item.imageUrl" class="bannerImg" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- <van-sticky :offset-top="0">
      <div class="sticky">
        <div class="tab" :class="active === index ? 'active' : ''" v-for="(item, index) in tabList" :key="index" @click="handleTab(index)">{{ item }}</div>
      </div>
    </van-sticky> -->
    <!-- 列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      offset="50"
      finished-text="没有更多了"
      class="listWrapper"
    >
      <div class="listContentWrapper">
        <van-cell v-for="(item, index) in list" :key="index" class="listContent">
          <div class="goodsImgWrapper">
            <div class="goodsCode">{{ item.code }}</div>
            <img :src="item.imageUrl" alt="" class="goodsImg">
            <img src="../../assets/toUp.png" alt="" class="toUpIcon" v-if="item.topFlag">
          </div>
          <div class="goodsMessageWrapper">
            <div>
              <div class="title">{{ item.productName }}</div>
              <div class="content">{{ item.description }}</div>
            </div>
            <div class="operation">
              <span class="price">售价： {{ parseFloat(item.price / 100).toFixed(2) }}元</span>
              <div type="info" class="placeBtn" size="small" @click="goPayOrder(item)">
                立即办理<van-icon name="arrow" />
              </div>
            </div>
          </div>
        </van-cell>
      </div>
    </van-list>
    <!-- <ul class="useList">
      <li class="useImgWrapper" @click="refresh">
        <img src="../../assets/homeLogo.png" alt="" class="useImg">
        <span class="useTitle">首页</span>
      </li>
      <li class="useImgWrapper" @click="gokf()">
        <img src="../../assets/kfLogo.png" alt="" class="useImg">
        <span class="useTitle">联系客服</span>
      </li>
      <li class="useImgWrapper" @click="goLink('report')">
        <img src="../../assets/complaintLogo.png" alt="" class="useImg">
        <span class="useTitle">投诉</span>
      </li>
    </ul> -->
    <!-- <ul class="homeAction" v-if="actionData.length > 0">
      <li class="homeActionItem" v-if="actionData.includes('1')" @click="goLink('report')">
        <img src="../../assets/homeTS.png" alt="" class="homeActionIcon">
        投诉反馈
      </li>
      <li class="homeActionItem" v-if="actionData.includes('2')" @click="goLink('order')">
        <img src="../../assets/homeDD.png" alt="" class="homeActionIcon">
        我的订单
      </li>
      <li class="homeActionItem" v-if="actionData.includes('3')" @click="gokf()">
        <img src="../../assets/homeKF.png" alt="" class="homeActionIcon">
        联系客服
      </li>
    </ul> -->
    <div class="kefu btn" @click="gokf()">
      <img src="../../assets/kf_icon.png" />
      <span>联系客服</span>
    </div>
    <div class="complaint btn" @click="goLink('report')">
      <img src="../../assets/complaint_icon.png" />
      <span>投诉</span>
    </div>
  </div>
</template>

<script>
import { getHomeList, getTitle, getHomeListCarousel } from '../../api/api'

export default {
  name: 'home',
  props: {
    id: {
      require: true
    }
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false, //是否有更多
      page: 1,
      pageSize: 10,
      // count: null,
      tabList: ['全部', '中国移动', '中国联通', '中国电信', '中国广电'],
      active: null, //tab切换
      shopListData: [], // 商品总数据
      carouselList: [],
      actionData: []
    }
  },
  created () {
    this.$store.commit('setUserId', this.$route.params.id)
    this.$store.commit('setUrl', window.location.href.split('/home')[0])
    sessionStorage.setItem('isHome2', true);
    sessionStorage.setItem('home2PathnameUrl', window.location.pathname);
    localStorage.setItem('isHome2', true);
    localStorage.setItem('home2PathnameUrl', window.location.pathname);
    this._getHomeData()
    this._getTitle()
    this.active = null;
  },
  methods: {
    // tab切换
    handleTab(index){
      this.active = index;
      if(this.active === 0) {
        this.list = this.shopListData;
        return
      }
      this.list = this.shopListData.filter(item => item.operator == this.active);
      window.scrollTo({
        top:0,
        behavior:'smooth'
      })
    },
    // 查询列表
    _getHomeData () {
      this.loading = true
      getHomeListCarousel(this.$route.params.id).then((res) => {
        if (res && res.code === 200) {
          this.carouselList = res.result
        }
      })
      getHomeList(this.$route.params.id).then(res => {
        if (res && res.code === 200) {
          // this.count = res.result.total
          if (res.code === 200) {
            this.shopListData = this.list = res.result;
            this.loading = false;
            this.finished = true
          }
        } else {
          this.loading = false
          this.finished = true
        }
      })
    },
    // 查询标题
    _getTitle () {
      getTitle(this.$route.params.id).then(res => {
        console.log(res)
        if (res.code === 200) {
          window.document.title = res.result.pageTitle
          this.actionData = res.result.imgSideFeatures
        }
      })
    },
    refresh () {
      this.active = null;
      this.list = []
      // this.count = null
      this.page = 1
      this.finished = false
      this._getHomeData()
    },
    // onLoad() {
    //   // 异步更新数据
    //   console.log('进来了')
    //   setTimeout(() => {
    //     if (this.list.length >= this.count) {
    //       this.finished = true
    //     } else {
    //       this.finished = false
    //       this.page++
    //       this._getHomeData()
    //     }
    //   }, 1000)
    // },
    // 跳转商品页
    goPayOrder (item) {
      switch (item.templateId) {
        case 1:
          // 模板一
          this.$router.push({
            path: `/jazlOrder/${item.pageId}?isJazl=true`, // type: true,是从家安智联App进入的
          })
          break;
        case 2:
          // 模板二
          this.$router.push({
            path: `/phoneOrder/index/${item.pageId}`
          })
          break;
        case 3:
          // 模板三
          this.$router.push({
            path: `/allInOne/index/${item.pageId}/${item.productId}`
          })
          break;
        case 4:
          this.$router.push({
            path: `/broadband/order/${item.pageId}`
          })
          break;
      }
    },
    goLink(type) {
      let url = new Map([
        ['order', '/order'],
        ['report', '/report']
      ])
      this.$router.push({
        path: url.get(type),
      })
    },
    gokf () {
      this.$router.push({
        path: `/kefu`,
      })
      // window.location.href = 'https://im-c.zmyiot.com/?appid=bdad6316'
    }
  }
}
</script>

<style lang="less" scoped>
  .home {
    min-height: 100%;
    background-color: #F7F6F2;
    margin-bottom: 50px;
    position: relative;
    .homeAction {
      position: fixed;
      right: 0;
      top: 40px;
      .homeActionItem {
        background-color: #000000;
        border-radius: 32px 0 0 32px;
        opacity: 0.8;
        margin-bottom: 15px;
        font-size: 16px;
        color: #fff;
        padding: 6px 10px;
        display: flex;
        align-items: center;
        .homeActionIcon {
          width: 18px;
          height: 18px;
          padding-right: 4px;
        }
      }
    }
    .banner {
      height: 173px;
      margin: 0;
      padding: 0;
      .bannerImg {
        width: 100%;
        height: 173px;
      }
    }
    .sticky{
      margin: 8px;
      border-radius: 6px;
      background-color: #FFF;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .tab{
        font-size: 15px;
        font-weight: bold;
        padding: 10px 0;
        border-top: 3px solid transparent;
        border-bottom: 3px solid transparent;
      }
      .active{
        color: #317ecc;
        border-bottom: 3px solid #317ecc;
      }
    }
    .listWrapper{
      margin-top: 20px;
      .listContentWrapper {
        margin: 8px 8px 0;
        .listContent {
          border-radius: 6px;
          margin-bottom: 10px;
          background-color: #fff;
          .goodsImgWrapper {
            position: relative;
            .goodsCode {
              position: absolute;
              top: 0;
              left: 0;
              background-color: #00000066;
              border-radius: 6px 0 6px 0;
              color: #fff;
              font-size: 13px;
              padding: 2px 10px;
              text-align: center;
            }
            .goodsImg {
              width: 119px;
              height: 119px;
              border-radius: 6px;
            }
            .toUpIcon {
              position: absolute;
              top: 0;
              right: 0;
              width: 33px;
              height: 33px;
            }
          }
          .goodsMessageWrapper {
            margin-left: 6px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
              line-height: 17px;
              font-size: 15px;
              font-weight: bold;
              color: #333;
              text-align: justify;
            }
            .content {
              color: #666;
              font-weight: 500;
              font-size: 12px;
              line-height: 14px;
              margin: 5px 0;
              display: -webkit-box;
              overflow: hidden;
              word-break: break-all; /* break-all(允许在单词内换行。) */
              text-overflow: ellipsis; /* 超出部分省略号 */
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2; /** 显示的行数 **/
            }
            .operation {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .price {
                color: #F23A54;
                font-weight: bold;
                font-size: 13px;
              }
              .placeBtn {
                font-size: 12px;
                font-weight: bold;
                color: #fff;
                border-radius: 6px;
                padding: 2px 8px;
                background-color: #398afd;
              }
            }
          }
        }
        .listContent:last-child{
          margin-bottom: 0;
        }
      }
    }
    // 功能列表logo
    .useList {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      display: flex;
      background-color: #fff;
      .useImgWrapper {
        height: 76px;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .useImg{
          width: 39px;
          height: 39px;
        }
        .useTitle {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
    .btn{
      position: fixed;
      left: 0;
      font-size: 16px;
      font-weight: 400;
      padding: 5px 12px;
      border-radius: 0 50px 50px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .kefu{
      bottom: 20%;
      color: #FFF;
      background-color: #F36251;
    }
    .complaint{
      bottom: 13%;
      color: #666666;
      background-color: #FFF;
    }
  }
  /deep/ .van-cell{
    padding: 6px;
  }
  /deep/ .van-cell__value {
    display: flex;
    justify-content: space-between;
  }
</style>
